import * as React from 'react';
import {BellIcon} from "components/widgets/icons/BellIcon";
import {observer} from "mobx-react";
import './NotificationBell.pcss';
import {handleSpacePressed} from "utils";
import {UIState} from "data/UIState";
import {PageEnums} from "components/nav/PageEnums";

interface Props {
  notificationCount:number;
  toggleNotifications?:(clickEvent)=>void;
}
export const NotificationBell = observer((props:Props) => {
  let notificationsMessage = "No notifications"
  if(props.notificationCount>0) {
    notificationsMessage = "You have "+props.notificationCount + " notification"+(props.notificationCount>1?"s":"");
  }

  return (
      <div role={"button"} tabIndex={0} className="notification-bell" aria-label={`Notifications (${notificationsMessage})`}
           onClick={props.toggleNotifications}
           onKeyDown={(e)=>{ handleSpacePressed(e, props.toggleNotifications);}}
      >
        <BellIcon />
        {props.notificationCount>0 && <div className={'red-bubble'} aria-hidden>{props.notificationCount>9?"9+":props.notificationCount}</div>}
      </div>
  );
});